import React, { useContext, useEffect } from "react";

import { Context, fetchActiveLearningThemes } from "../../../teacherStore";
import ActiveLearningThemes from "../../../templates/teacher/ActiveLearningThemes";

export default () => {
  const { dispatch } = useContext(Context);

  useEffect(() => {
    dispatch(fetchActiveLearningThemes());
  }, [dispatch]);

  return <ActiveLearningThemes />;
};
